/**
 * 6-color palette surfaced by the Subject Areas admin UI as one-click
 * presets. The picker also offers a "Custom" tile that opens the native
 * color picker, so admins can dial in any hex value; the backend already
 * accepts any `#RRGGBB` string. These presets stay as sensible defaults.
 */
export const SUBJECT_AREA_PALETTE = [
  { name: "Blue", hex: "#3B82F6" },
  { name: "Teal", hex: "#14B8A6" },
  { name: "Purple", hex: "#8B5CF6" },
  { name: "Green", hex: "#22C55E" },
  { name: "Amber", hex: "#F59E0B" },
  { name: "Rose", hex: "#F43F5E" },
] as const;

export type SubjectAreaPaletteEntry = (typeof SUBJECT_AREA_PALETTE)[number];
